'use client'

import { ContactsOrganisationsSelectModal } from '@repo/contacts-organisations/ContactsOrganisationsSelectModal'
import {
  CustomDataContactsOrganisationsEditState,
  CustomDataContactsOrganisationsEditStateRow
} from '@repo/custom-data-pages/CustomDataContactsOrganisationsEditState'
import { TextLinkButton } from '@repo/ui/TextLinkButton'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useState, useEffect } from 'react'
import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'

export const CustomDataFieldOrganisation = ({ value, onChange, field, validationErrors }) => {
  const [showDialog, setShowDialog] = useState(false)
  const [organisation, setOrganisation] = useState(null)

  const { fetchOrganisationById, organisationsById } = useLookupsStore()
  const { allowedActions } = useMenuItemsStore()
  const allowEditOrganisations = allowedActions?.editOrganisations?.allowed || false

  const handleSelection = (selectedItem) => {
    if (selectedItem) {
      const { organisationId } = selectedItem
      if (onChange) onChange(organisationId)
    } else {
      if (onChange) onChange(null)
      setOrganisation(null)
    }
    setShowDialog(false)
  }

  const clearOrganisation = () => {
    if (onChange) onChange(null)
    setOrganisation(null)
  }

  useEffect(() => {
    if (!value) {
      setOrganisation(null)
      return
    }

    const fetchOrganisation = async () => {
      const organisation = await fetchOrganisationById({ id: value })
      setOrganisation(organisation)
    }

    if (organisationsById?.[value]) {
      setOrganisation(organisationsById[value])
    } else {
      fetchOrganisation()
    }
  }, [value, fetchOrganisationById, organisationsById])

  const hasErrors = validationErrors?.length > 0 || false

  return (
    <>
      <MUIStack
        data-testid="CustomDataFieldOrganisation"
        direction="column"
        sx={{
          border: `1px solid ${hasErrors ? '#C33241' : 'rgb(0, 0, 0, 0.23)'}`,
          borderRadius: '4px',
          width: '100%'
        }}
      >
        <CustomDataContactsOrganisationsEditStateRow
          title="Organisation"
          label={
            <MUIStack direction="row" justifyContent="flex-end" alignItems="center" gap={0} sx={{ width: '100%' }}>
              <TextLinkButton
                title={allowEditOrganisations ? 'Add / Edit / Select' : 'Select'}
                onClick={() => setShowDialog(true)}
                sx={{ mt: 0, minWidth: 'unset', width: 'auto', p: '0 10px' }}
              />
              <span style={{ color: 'rgb(0, 0, 0, 0.36)' }}>|</span>
              <TextLinkButton
                title={'Clear'}
                onClick={clearOrganisation}
                sx={{ mt: 0, minWidth: 'unset', width: 'auto', p: '0 10px' }}
              />
            </MUIStack>
          }
          isFirst
        />

        <CustomDataContactsOrganisationsEditState item={organisation} mode="organisations" />
      </MUIStack>
      <ContactsOrganisationsSelectModal
        open={showDialog}
        onClose={handleSelection}
        initialSelectedItem={organisation}
        mode="organisations"
        preSelectExpertTypeId={field?.expertTypeId || null}
      />
    </>
  )
}

CustomDataFieldOrganisation.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  field: PropTypes.object,
  validationErrors: PropTypes.array,
  fieldTypeIsString: PropTypes.bool,
  fieldTypeIsNumber: PropTypes.bool,
  fieldTypeIsAnId: PropTypes.bool
}
